import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export enum ValidationErrorKeys {
  // these covert the standard ng forms' validator keys, thus lowercase
  REQUIRED = 'required',
  MIN_LENGTH = 'minlength',
  MAX_LENGTH = 'maxlength',

  // our own validators
  MIN_COORDINATE = 'min',
  MAX_COORDINATE = 'max',
  PATTERN_NUMERIC = 'pattern',
  CONTAINS_ONLY_WHITESPACE = 'containsOnlyWhitespace',
}


/**
 * Returns an error if the input field contains whitespaces only (empty input is fine).
 */
export const excludeWhitespaceOnly: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const forbidden = control.value !== null
      && control.value.length > 0
      && control.value.trim().length === 0;

  return forbidden
      ? { [ValidationErrorKeys.CONTAINS_ONLY_WHITESPACE]: true }
      : null;
};

/**
 * Combine a couple of validators for the custom services.
 */
export const customServicesValidators = {
  serviceName: [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(140),
    excludeWhitespaceOnly,
  ],
  serviceDescription: [
    Validators.maxLength(250),
    excludeWhitespaceOnly,
  ],
  serviceCategoryId: [
    Validators.minLength(7),
    Validators.maxLength(42),
    excludeWhitespaceOnly,
  ],
};

export const LatitudeValidators = [
  Validators.min(-90),
  Validators.max(90),
  Validators.pattern(/^(?!-0(\.0+)?$)-?(0|[1-9]\d*)(\.\d+)?$/)];

export const LongitudeValidators = [
  Validators.min(-180),
  Validators.max(180),
  Validators.pattern(/^(?!-0(\.0+)?$)-?(0|[1-9]\d*)(\.\d+)?$/)];

/**
 * If 1 FC value is present, the other must be too
 * @param fromControlName
 * @param toControlName
 */
export const dateRangeIncompleteValidator = (fromControlName = 'from', toControlName = 'to'): ValidatorFn => {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const fromControl = formGroup.get(fromControlName);
    const toControl = formGroup.get(toControlName);

    // Determine if the range is incomplete (one has value, the other does not)
    const isIncomplete = (fromControl?.value && !toControl?.value) || (!fromControl?.value && toControl?.value);

    if (isIncomplete) {
      // If incomplete, set the 'required' error on the relevant individual control(s).
      if (!fromControl?.value) {
        fromControl.setErrors({ ...fromControl.errors, required: true });
      }
      if (!toControl?.value) {
        toControl.setErrors({ ...toControl.errors, required: true });
      }
      // Return the group-level error as well (optional, but good for form-level validation summary)
      return { incompleteDateRange: true };
    } else {
      // If validation passes, we must CLEAR the 'required' error from the FC
      let fromErrors = fromControl.errors;
      if (fromErrors && fromErrors['required']) {
        fromErrors = { ...fromErrors }; // Create a copy to modify
        delete fromErrors['required'];
        fromControl.setErrors(Object.keys(fromErrors).length ? fromErrors : null);
      }

      let toErrors = toControl.errors;
      if (toErrors && toErrors['required']) {
        toErrors = { ...toErrors }; // Create a copy to modify
        delete toErrors['required'];
        toControl.setErrors(Object.keys(toErrors).length ? toErrors : null);
      }
      // Group-level validation passes
      return null;
    }
  };
};